/**
 * This is an auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import type { ApiScaleInfo, ApiWeighing } from '@Model';
import type { HttpActions, Result } from '@synqo/frontend-component-library';

/**
 * Calls the endpoints of ScalesController.
 */
export class ScalesRepository {
    constructor(private readonly http: HttpActions) {}

    /**
     * Calls GET /scales/connected
     */
    public getScales(): Promise<Result<ApiScaleInfo[]>> {
        return this.http.get<Result<ApiScaleInfo[]>>('/scales/connected');
    }

    /**
     * Calls GET /scales/{scaleId}/weighing
     */
    public getWeight(scaleId: string): Promise<Result<ApiWeighing>> {
        return this.http.get<Result<ApiWeighing>>(`/scales/${scaleId}/weighing`);
    }
}
